<template>
    <div class="titleInfo" v-if="rtgId">

            <div class="spiderTitle">
                Bewertungsergebnisse der Suchfelder
            </div>

            <div>
                Die Grafiken bilden die Bewertungen der einzelnen Suchfelder ab,
                um die verschiedenen Gewichtungen der Themengebiete zu visualisieren:
            </div>
      

    </div>

    <div class="suBox">
        <div class="suFor" v-for="item in suchFelder" :key="item.SufId">
           
            <div class="suTitle">
                {{item.Suchfeld}}
            </div>
            <div class="suChart">


                <DxPolarChart id="chart"
                              :data-source="item.Items"
                              :use-spider-web="true">
                    <DxSize :height="300"
                            :width="400" />

                    <DxCommonSeriesSettings type="area" value-field="WgtAvg"
                                            argument-field="RtyCaption"
                                            :color="item.paletteSf" />
                    <DxSeries :name="item.Suchfeld" />
                    <DxExport :enabled="false" />

                    <DxTooltip :enabled="true" />
                </DxPolarChart>
            </div>


        </div>
    </div>

    <!--<DxPolarChart id="chart"
                  :data-source="dataSource"
                  :use-spider-web="true"
                  title="Fruit Production in 2010 (Millions of Tons)">
        <DxCommonSeriesSettings type="line" :argument-field="Items" :value-field="WgtAvg"/>
        <DxSeries v-for="item in dataSource"
                  :key="item.SufId"
                  :value-field="WgtAvg"
                  :argument-field="RtyCaption"
                  :name="item.Suchfeld" />
        <DxExport :enabled="true" />
        <DxSeriesTemplate name-field="Items">

        </DxSeriesTemplate>
        <DxTooltip :enabled="true" />
    </DxPolarChart>-->

</template>
<script>
    import {
        DxPolarChart,
        DxCommonSeriesSettings,
        DxSeries,
        DxExport,
        DxTooltip,
      
        DxSize

    } from 'devextreme-vue/polar-chart';

    export default {

        components: {
            DxPolarChart,
            DxCommonSeriesSettings,
            DxSeries,
            DxExport,
            DxTooltip,
           
            DxSize

        },
        data() {
            return {
                rtgId: null,
                clpalette: [
                    '#205d72',
                    '#f4c543',
                    '#c32974',
                    '#e6f1ee',
                    '#49a1be',
                    '#cb5144'
                ],
                categories: []
            };
        },
        computed: {
            dataSource() {

                return this.suchFelder;
            },
            getDataSource(sfId) {
                return this.$store.state.statisticsStore.suchfeldBewertungStats.filter(m => {
                    return m.SufId == sfId
                })
            },
            suchFelder() {
                var suchfeld = this.$store.state.statisticsStore.suchfeldBewertungStats;
                var n = 0;

                suchfeld.map(m => {

                    m.paletteSf = this.getpalette(n)
                    n++

                })
                return suchfeld;
            }
        },

        methods: {
       
            getpalette(n) {
                return this.clpalette[n % 6];
            }
        },
        created: function () {
            window.addEventListener("rtgIdChanged", function () {

                this.rtgId = window.State.getRtgId()
                this.$store.dispatch("getSuchfeldBewertungStats", { RtgId: this.rtgId })
            }.bind(this), false)

        },
    }


</script>
<style scoped>
    .chtBox {
        background: #ffffff1a;
    }

    #chart {
        padding-bottom: 50px;
    }

    ul {
        display: inline-flex;
        flex-direction: row;
        flex-wrap: wrap;
        flex: 0 0 33.333333%;
    }

    li {
        list-style-type: none;
    }

    .titleInfo {
        padding-left: 10px;
        padding-bottom: 20px
    }

 
    
    .suBox {
        display: grid;
        grid-auto-flow: column;
        grid-template-columns: repeat(6, 400px);
        grid-template-rows: repeat(2, auto auto);
        column-gap: 30px;
    }

    .suTitle {
        justify-self: center;
        text-align: center;
        line-height: 1.6;
        font-family: var(--font-family);
        font-size:15px;
        font-weight:bold;
    }
    .bitv .suTitle{
      
    }
    .suFor {
        display: contents;
    }
    .spiderTitle {
        color: #717c86;
        margin-bottom: 8px;
        font-family: var(--font-family);
        font-weight: bold;
        font-size: 18px;
    }

</style>